import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';

export const NoDocuments = ({ docType, fullMessage }) => {
  const message = fullMessage || `You have no recent ${docType} claims.`;

  return (
    <section className="noFilteredClaims">
      <Icon icon="inbox" />
      {message}
    </section>
  );
};

NoDocuments.propTypes = {
  docType: PropTypes.string,
  fullMessage: PropTypes.string
};
